import { Api } from '@/api/api.client';
import type { Components } from '@/api/generated/api';

export async function fetchAppConfig(): Promise<Components.Schemas.AppConfigDataDto> {
  const res = await Api.Routes.App.getAppConfig();
  return res.data;
}
